import { render, staticRenderFns } from "./FinalProductTable.vue?vue&type=template&id=5452b075&scoped=true&lang=pug"
import script from "./FinalProductTable.vue?vue&type=script&lang=js"
export * from "./FinalProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452b075",
  null
  
)

export default component.exports